import { Navigate } from '@sorare/routing';

import { FOOTBALL_MARKET } from '@sorare/core/src/constants/__generated__/routes';

const MarketWildcardPage = () => {
  return <Navigate to={FOOTBALL_MARKET} replace keepParams />;
};
export default MarketWildcardPage;
